import { Box, Skeleton } from "@mui/material";
import SysColumn from "app/class/sys-column";

interface RecordProducerSkeletonComponentProps {
    columnList: SysColumn[];
}
const RecordProducerSkeletonComponent = ({ columnList }: RecordProducerSkeletonComponentProps) => {

    return (
        <Box gap={2} display="grid">
            {columnList.map((column) => {
                // Random width for skeletons | Formula: Math.floor(Math.random() * (max - min + 1)) + min;
                const random = Math.floor(Math.random() * (19 - 4 + 1)) + 4;
                return (
                    <Box key={`col_${column.id}_box`}>
                        <Skeleton variant="text" sx={{ minHeight: "4px", width: `${random}%` }} />
                        <Skeleton variant="rounded" sx={{ minHeight: "45px" }} />
                    </Box>
                )
            })}
        </Box>
    );
}

export default RecordProducerSkeletonComponent;